import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0677ba",
      d: "M16.305.788a.2.2 0 0 1 .252.27l-6.328 14.246a.2.2 0 0 1-.368-.005L7.594 9.794a.2.2 0 0 0-.102-.106L1.1 6.788a.2.2 0 0 1 .013-.37z"
    }, null, -1)
  ]))]))
}
export default { render: render }